import styled from "styled-components";
import Theme from "../../Styles/Themes";
import config from '../../Config/config.json';
import SVG from "react-inlinesvg";

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
`;

export const ContainerInput = styled.div`
    display: flex;
    width: 100%;
    border:  ${props => props.$isvalid ? '2px solid'+props.$borderColor : '2px solid #FF3939'};
    border-radius: 10px;
    padding: 2px 12px 2px 12px;
    justify-content: center;
    align-items: center;
    max-height: 66px;
    cursor: pointer;
`;

export const SelectInput = styled.select`
    display: flex;
    width: 100%;
    background: transparent;
    color: #006560;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    font-style: normal;
    font-weight: 400;
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    padding: 10px 8px 10px 15px;
    border: none;
    outline: none;
    @media (min-width: 720px) {
        padding: 17px 12px 19px 24px;
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    }
    @media (orientation: landscape) and (max-width: 1080px){
        padding: 10px;
        font-size: ${Theme[config.theme].font.labels['small'].size};
    }
`;

export const SelectOption = styled.option`
    display: flex;
    width: 100%;
    background: transparent;
    color: #006560;
    font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    font-style: normal;
    font-weight: 400;
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    padding: 17px 12px 19px 24px;
    border: none;
    outline: none;
`;

export const InvalidText = styled.label`
    display: flex;
    width: 88%;
    color: #FF3939;
    font-size: ${Theme[config.theme].font.paragraphs[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.paragraphs[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.paragraphs[config.fontSize].line_height};
    visibility: ${props => props.$visibility? 'hidden' : 'visible'};
`;

export const ImageIcons = styled(SVG)`
    width: 24px;
    height: 24px;
    & path {
        fill: ${({ color }) => color};
    }
`;